<template>
  <v-container id="app-info-badge-offline">
    <screen
      title="Solde"
      :info="soldeFormatted"
      class="ma-1"
    />

    <div class="bloc-action px-1">
      <div
        v-if="showHashCode"
        class="d-flex"
      >
        <h3>
          <span class="subtitle-1">{{ $t('field.scan.reload_code') }}</span>
          <br>
          <span class="title">{{ infos.hashCode }}</span>
        </h3>
        <v-spacer />
        <printer
          :tickets="codeTicket"
          use-activator
          icon
        />
      </div>

      <v-divider class="my-1" />

      <div
        v-show="formatData !== ''"
        class="text-center"
      >
        <h3>
          <span class="subtitle-1">{{ $t('ticket_number') }}</span>
          <br>
          <span class="title">{{ formatData }}</span>
        </h3>
        <v-divider class="my-1" />
      </div>

      <v-btn
        v-if="useOnlineRefill"
        color="success"
        class="bloc ml-0"
        style="height: 60px;"
        :disabled="!isConnected"
        @click="checkRefill"
      >
        {{ $t('field.scan.reload') }}<br>
        ({{ $t('field.scan.prepayment') }})
      </v-btn>

      <div
        v-if="transactions.length === 0"
        class="text-center mt-3"
      >
        <h3 class="title">
          {{ $t('field.scan.no_trx_card') }}
        </h3>
      </div>

      <div v-else>
        <v-card
          v-for="(transac, index) in transactions"
          v-show="transac.type !== 0"
          :key="index"
          class="my-3"
        >
          <v-card-text>
            Type : {{ formatType(transac.type) }}<br>
            Montant : {{ $amount(transac.amount) }}<br>
            Date : {{ formatDate(transac.date) }}<br>
            Heure : {{ formatTime(transac.time) }}<br>
            Terminal ID : {{ transac.idTerm }}<br>
            Solde : {{ $amount(transac.solde) }}
          </v-card-text>
          <v-card-action
            v-show="index === 0 && (transac.type <= 2 || transac.type === 6) && transac.idTerm === idTerm"
          >
            <v-btn
              color="danger"
              class="bloc ma-0"
              text
              @click="cancelTransac(transac)"
            >
              {{ $t('field.scan.cancel_op') }}
            </v-btn>
          </v-card-action>
        </v-card>
      </div>
    </div>
    <bottom-action
      btn-cancel
      btn-valid-disabled
      @del="del"
      @cancel="cancel"
    />
  </v-container>
</template>

<script>
import { MetierLocalStorage } from 'modulelocalstorage'
import { ActionEnum, ServerEnum } from '@/modules/Enums'
import { Scan } from '@/modules/Scan'
import { $alert, $amount } from '@/modules/Utils'
import Printer from '@/components/Printer'

export default {
  name: 'InfoBadgeOfflineView',

  components: {
    Printer
  },

  props: {
    infos: { type: Object, required: true }
  },

  data () {
    return {
      idTerm: MetierLocalStorage.getIdPointDeVente() % 65535,
      transactions: [],
      soldeFormatted: $amount(0)
    }
  },

  computed: {
    formatData () {
      let hex = this.infos.data
      if (parseInt(hex, 2) === 0 || hex.substring(0, 4).toUpperCase() === '11FF') {
        return ''
      } else {
        let str = ''
        for (var n = 0; n < hex.length; n += 2) {
          let part = hex.substr(n, 2)
          if (part.toUpperCase() === '3B') {
            break
          }
          str += String.fromCharCode(parseInt(part, 16))
        }
        return str
      }
    },
    isConnected () { return this.$store.getters.isConnected },
    useOnlineRefill () { return this.$store.getters.useOnlineRefill },
    showHashCode () {
      return this.infos.hashCode !== undefined && this.infos.hashCode !== null
    },
    codeTicket () {
      return this.showHashCode ? [{
        Image: null,
        Lignes: [
          { Msg: 'CASHLESS', Souligne: 1, Align: 'C', Taille: 2 },
          { Msg: '--------------------', Align: 'C', Taille: 2 },
          { Msg: this.$i18n.t('tickets.offline_site'), Align: 'L', Taille: 2 },
          { Msg: MetierLocalStorage.getSiteWeb(), Align: 'L', Taille: 2 },
          { Msg: this.$i18n.t('tickets.offline_code'), Align: 'L', Taille: 2 },
          { Msg: '   ', Align: 'L', Taille: 2 },
          { Msg: this.infos.hashCode, Gras: 1, Align: 'R', Taille: 2 },
          { Msg: '--------------------', Align: 'C', Taille: 2 },
          { Msg: this.$i18n.t('tickets.thx'), Align: 'C', Taille: 2 }
        ]
      }] : []
    }
  },

  beforeMount () {
    this.soldeFormatted = $amount(this.infos.solde)
    let transacs = []
    switch (this.infos.last) {
      case 1:
        transacs.push(this.infos.transactions[0])
        transacs.push(this.infos.transactions[2])
        transacs.push(this.infos.transactions[1])
        break
      case 2:
        transacs.push(this.infos.transactions[1])
        transacs.push(this.infos.transactions[0])
        transacs.push(this.infos.transactions[2])
        break
      case 3:
        transacs.push(this.infos.transactions[2])
        transacs.push(this.infos.transactions[1])
        transacs.push(this.infos.transactions[0])
        break
      default:
        break
    }
    this.transactions = transacs
  },

  methods: {
    $amount,
    del () {
      this.$router.replace({
        name: 'scan-nfc-offline',
        params: { action: ActionEnum.badgeInformations, backToHome: true }
      })
    },
    cancel () {
      this.$router.replace('/home')
    },
    //
    formatDate (date) {
      return date.substring(6) + '/' + date.substring(4, 6) + '/' + date.substring(0, 4)
    },
    formatTime (time) {
      return time.substring(0, 2) + 'H' + time.substring(2)
    },
    formatType (type) {
      switch (type) {
        case 1:
          return this.$i18n.t('field.scan.debit')
        case 2:
          return this.$i18n.t('field.scan.credit')
        case 58:
          return this.$i18n.t('field.scan.credit_online')
        case 3:
          return this.$i18n.t('field.scan.cancel_credit')
        case 4:
          return this.$i18n.t('field.scan.cancel_debit')
        case 6:
          return this.$i18n.t('field.scan.activation_fee')
        default:
          break
      }
    },
    //
    checkRefill () {
      Scan.checkRefill(this.infos.uid, this.infos)
    },
    //
    cancelTransac (transac) {
      let action = null
      let amount = null

      switch (transac.type) {
        // Annulation d'un débit
        case ServerEnum.typeTransactionDebit:
          ({ amount } = transac)
          action = ActionEnum.cancelDebitOffline
          break

        // Annulation d'un crédit
        case ServerEnum.typeTransactionCredit:
          if (this.infos.solde < transac.amount) {
            $alert(this.$i18n.t('error.offline_solde_insufficient'))
            return
          }
          ({ amount } = transac)
          action = ActionEnum.cancelCreditOffline
          break

        // Annulation des frais d'activations
        case ServerEnum.typeTransactionActivation:
          ({ amount } = this.transactions[1])
          action = ActionEnum.cancelActivationOffline
          break

        // Autre action non autorisée
        default:
          return
      }

      this.$emit('title', this.$i18n.t('title.cashless_cancel',
        { type: action === ActionEnum.cancelDebitOffline ? 'débit' : 'crédit' }
      ))
      this.$store.commit('amount', amount)
      this.$router.replace({
        name: 'scan-nfc-offline',
        params: { action: action, uid: this.infos.uid }
      })
    }
  }
}
</script>
